import React, { ChangeEventHandler, FocusEventHandler } from "react";
import parse from "html-react-parser";

import { signUpTermsParser } from "@utils/signUpTermsParser";
import { SignUpTermsQuery } from "@StaticQueries/SignUpTerms.query";
import { useFormData } from "@sp-state/useFormData";

import styles from "./AgreementInput.module.scss";

const AgreementInput = () => {
  const { agreement, setError, setAgreementValue, setIsValid } = useFormData(
    state => state
  );
  const termsAgreementData = SignUpTermsQuery();

  const onBlur: FocusEventHandler<HTMLInputElement> = e => {
    if (!e.target.checked) {
      setError("agreement", true);
      setIsValid("agreement", false);
    }
  };

  const onChange: ChangeEventHandler<HTMLInputElement> = e => {
    const { checked } = e.target;
    if (agreement.hasError) setError("agreement", false);

    setAgreementValue("agreement", checked);

    if (checked) {
      setIsValid("agreement", true);
    }
  };

  const textContent = termsAgreementData ? (
    <>
      {parse(termsAgreementData.termsAgreementText!, {
        replace: signUpTermsParser,
      })}
    </>
  ) : (
    <p>
      On behalf of myself and the practice, I agree to the{" "}
      <a href="/baa" target="_blank">
        Business Associate Agreement
      </a>
      , the{" "}
      <a href="/terms" target="_blank">
        Terms of Service
      </a>
      , and the{" "}
      <a href="/privacy" target="_blank">
        Privacy Policy
      </a>{" "}
      for my account.
    </p>
  );

  return (
    <fieldset className={styles.agreementField}>
      <input
        checked={agreement.checked}
        onBlur={onBlur}
        onChange={onChange}
        type="checkbox"
        className={styles.checkbox}
      />
      {textContent}
    </fieldset>
  );
};

export default AgreementInput;
